var _path, _path2, _rect, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g3, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 424,
    viewBox: "0 0 500 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1818_26502)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.4127 63.1751C84.4127 63.1751 -8.38538 167.622 9.03117 200.441C26.4477 233.26 106.951 193.443 101.017 208.49C95.0833 223.537 6.45981 315.381 38.6175 356.394C70.7751 397.408 210.253 312.032 200.093 348.948C189.932 385.865 191.431 430.424 250.729 422.625C310.026 414.826 373.197 293.054 369.012 317.596C364.827 342.137 351.834 429.436 409.716 405.176C467.598 380.915 496.768 269.293 484.171 191.997C471.575 114.702 435.149 154.207 420.772 151.441C406.395 148.675 458.718 42.6788 430.683 15.6208C402.647 -11.4373 268.458 87.779 253.613 93.1137C238.767 98.4484 289.508 5.4922 242.963 0.979058C196.418 -3.53408 146.75 5.97055 84.4127 63.1751Z",
    fill: "#76CCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M84.4127 63.1751C84.4127 63.1751 -8.38538 167.622 9.03117 200.441C26.4477 233.26 106.951 193.443 101.017 208.49C95.0833 223.537 6.45981 315.381 38.6175 356.394C70.7751 397.408 210.253 312.032 200.093 348.948C189.932 385.865 191.431 430.424 250.729 422.625C310.026 414.826 373.197 293.054 369.012 317.596C364.827 342.137 351.834 429.436 409.716 405.176C467.598 380.915 496.768 269.293 484.171 191.997C471.575 114.702 435.149 154.207 420.772 151.441C406.395 148.675 458.718 42.6788 430.683 15.6208C402.647 -11.4373 268.458 87.779 253.613 93.1137C238.767 98.4484 289.508 5.4922 242.963 0.979058C196.418 -3.53408 146.75 5.97055 84.4127 63.1751Z",
    fill: "#252730"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 358,
    width: 178,
    height: 67,
    fill: "#343643"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.518 140.346H185.028V146.699H202.518V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 131.34H185.028V137.694H202.518V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 122.345H185.028V128.699H202.518V122.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 113.34H185.028V119.693H202.518V113.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 140.346H230.345V146.699H247.834V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 131.34H230.345V137.694H247.834V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 140.346H139.723V146.699H157.212V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 131.34H139.723V137.694H157.212V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 140.346H162.375V146.7H179.865V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 131.34H162.375V137.694H179.865V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 122.345H162.375V128.699H179.865V122.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 113.34H162.375V119.693H179.865V113.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 104.345H162.375V110.698H179.865V104.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 95.3495H162.375V101.703H179.865V95.3495Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 86.344H162.375V92.6977H179.865V86.344Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 140.346H207.682V146.699H225.171V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 131.34H207.682V137.694H225.171V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 122.345H207.682V128.699H225.171V122.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 113.34H207.682V119.693H225.171V113.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 104.345H207.682V110.698H225.171V104.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 95.3495H207.682V101.703H225.171V95.3495Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 140.346H298.158V146.699H315.648V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 131.34H298.158V137.694H315.648V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 122.345H298.158V128.699H315.648V122.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 113.34H298.158V119.693H315.648V113.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 140.346H343.464V146.699H360.954V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 131.34H343.464V137.694H360.954V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 140.346H252.842V146.699H270.331V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 131.34H252.842V137.694H270.331V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 140.346H275.505V146.699H292.995V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 131.34H275.505V137.694H292.995V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 122.345H275.505V128.699H292.995V122.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 113.34H275.505V119.693H292.995V113.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 104.345H275.505V110.698H292.995V104.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 95.3495H275.505V101.703H292.995V95.3495Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 86.344H275.505V92.6977H292.995V86.344Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 140.346H320.812V146.699H338.301V140.346Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 149.289H185.028V155.643H202.518V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 149.289H230.345V155.643H247.834V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 149.289H139.723V155.643H157.212V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 149.289H162.375V155.643H179.865V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 149.289H207.682V155.643H225.171V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 149.289H298.158V155.643H315.648V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 149.289H343.464V155.643H360.954V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 149.289H252.842V155.643H270.331V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 149.289H275.505V155.643H292.995V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 149.289H320.812V155.643H338.301V149.289Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 158.232H185.028V164.586H202.518V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 158.232H230.345V164.586H247.834V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 158.232H139.723V164.586H157.212V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 158.232H162.375V164.586H179.865V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 158.232H207.682V164.586H225.171V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 158.232H298.158V164.586H315.648V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 158.232H343.464V164.586H360.954V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 158.232H252.842V164.586H270.331V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 158.232H275.505V164.586H292.995V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 158.232H320.812V164.586H338.301V158.232Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 167.175H185.028V173.529H202.518V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 167.175H230.345V173.529H247.834V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 167.175H139.723V173.529H157.212V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 167.175H162.375V173.529H179.865V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 167.175H207.682V173.529H225.171V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 167.175H298.158V173.529H315.648V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 167.175H343.464V173.529H360.954V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 167.175H252.842V173.529H270.331V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 167.175H275.505V173.529H292.995V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 167.175H320.812V173.529H338.301V167.175Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 131.34H320.812V137.694H338.301V131.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 122.345H320.812V128.699H338.301V122.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 113.34H320.812V119.693H338.301V113.34Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 104.345H320.812V110.698H338.301V104.345Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 95.3495H320.812V101.703H338.301V95.3495Z",
    fill: "#252730"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.518 291.806H185.028V298.16H202.518V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 282.811H185.028V289.165H202.518V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 273.806H185.028V280.159H202.518V273.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 264.811H185.028V271.164H202.518V264.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 291.806H230.345V298.16H247.834V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 282.811H230.345V289.165H247.834V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 291.806H139.723V298.16H157.212V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 282.811H139.723V289.165H157.212V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 291.806H162.375V298.16H179.865V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 282.811H162.375V289.165H179.865V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 273.806H162.375V280.159H179.865V273.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 264.811H162.375V271.164H179.865V264.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 255.805H162.375V262.159H179.865V255.805Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 246.81H162.375V253.164H179.865V246.81Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 237.815H162.375V244.169H179.865V237.815Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 291.806H207.682V298.16H225.171V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 282.811H207.682V289.165H225.171V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 273.806H207.682V280.159H225.171V273.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 264.811H207.682V271.164H225.171V264.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 255.805H207.682V262.159H225.171V255.805Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 246.81H207.682V253.164H225.171V246.81Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 291.806H298.158V298.16H315.648V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 282.811H298.158V289.165H315.648V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 273.806H298.158V280.159H315.648V273.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 264.811H298.158V271.164H315.648V264.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 291.806H343.464V298.16H360.954V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 282.811H343.464V289.165H360.954V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 291.806H252.842V298.16H270.331V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 282.811H252.842V289.165H270.331V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 291.806H275.505V298.16H292.995V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 282.811H275.505V289.165H292.995V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 273.806H275.505V280.159H292.995V273.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 264.811H275.505V271.164H292.995V264.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 255.805H275.505V262.159H292.995V255.805Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 246.81H275.505V253.164H292.995V246.81Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 237.815H275.505V244.169H292.995V237.815Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 291.806H320.812V298.16H338.301V291.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 300.749H185.028V307.103H202.518V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 300.749H230.345V307.103H247.834V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 300.749H139.723V307.103H157.212V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 300.749H162.375V307.103H179.865V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 300.749H207.682V307.103H225.171V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 300.749H298.158V307.103H315.648V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 300.749H343.464V307.103H360.954V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 300.749H252.842V307.103H270.331V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 300.749H275.505V307.103H292.995V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 300.749H320.812V307.103H338.301V300.749Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 309.693H185.028V316.046H202.518V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 309.693H230.345V316.046H247.834V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 309.693H139.723V316.046H157.212V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 309.693H162.375V316.046H179.865V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 309.693H207.682V316.046H225.171V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 309.693H298.158V316.046H315.648V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 309.693H343.464V316.046H360.954V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 309.693H252.842V316.046H270.331V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 309.693H275.505V316.046H292.995V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 309.693H320.812V316.046H338.301V309.693Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 318.646H185.028V325H202.518V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 318.646H230.345V325H247.834V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 318.646H139.723V325H157.212V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 318.646H162.375V325H179.865V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.171 318.646H207.682V325H225.171V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.648 318.646H298.158V325H315.648V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.954 318.646H343.464V325H360.954V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.331 318.646H252.842V325H270.331V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.995 318.646H275.505V325H292.995V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 318.646H320.812V325H338.301V318.646Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 282.811H320.812V289.165H338.301V282.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 273.806H320.812V280.159H338.301V273.806Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 264.811H320.812V271.164H338.301V264.811Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 255.805H320.812V262.159H338.301V255.805Z",
    fill: "#252730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.301 246.81H320.812V253.164H338.301V246.81Z",
    fill: "#252730"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M468.285 172.754C486.609 154.451 486.609 124.776 468.285 106.472C449.962 88.1693 420.254 88.1693 401.931 106.472C383.608 124.776 383.608 154.451 401.931 172.754C420.254 191.057 449.962 191.057 468.285 172.754Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M435.107 174.412C454.351 174.412 469.951 158.83 469.951 139.607C469.951 120.385 454.351 104.802 435.107 104.802C415.864 104.802 400.264 120.385 400.264 139.607C400.264 158.83 415.864 174.412 435.107 174.412Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M435.107 169.296C451.522 169.296 464.829 156.004 464.829 139.607C464.829 123.21 451.522 109.918 435.107 109.918C418.693 109.918 405.386 123.21 405.386 139.607C405.386 156.004 418.693 169.296 435.107 169.296Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M441.01 139.607C441.01 140.773 440.664 141.913 440.015 142.883C439.367 143.853 438.445 144.608 437.366 145.055C436.288 145.501 435.101 145.618 433.956 145.39C432.811 145.163 431.759 144.601 430.933 143.776C430.108 142.952 429.546 141.901 429.318 140.757C429.09 139.614 429.207 138.428 429.654 137.351C430.101 136.273 430.857 135.353 431.828 134.705C432.799 134.057 433.94 133.711 435.107 133.711C435.882 133.711 436.65 133.863 437.366 134.16C438.082 134.456 438.733 134.89 439.281 135.438C439.829 135.985 440.264 136.635 440.561 137.351C440.857 138.066 441.01 138.833 441.01 139.607Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M437.033 99.3218C437.035 98.9947 436.94 98.6745 436.76 98.4014C436.58 98.1284 436.323 97.9149 436.021 97.7878C435.719 97.6608 435.387 97.626 435.065 97.6877C434.744 97.7495 434.448 97.9051 434.215 98.1349C433.982 98.3647 433.822 98.6583 433.757 98.9786C433.691 99.2989 433.721 99.6316 433.845 99.9345C433.968 100.237 434.179 100.497 434.45 100.68C434.721 100.864 435.04 100.963 435.367 100.965C435.585 100.968 435.801 100.927 436.003 100.846C436.205 100.764 436.389 100.644 436.544 100.491C436.699 100.338 436.822 100.156 436.906 99.9554C436.99 99.7546 437.033 99.5393 437.033 99.3218Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.388 180.995C436.296 180.995 437.033 180.259 437.033 179.352C437.033 178.444 436.296 177.709 435.388 177.709C434.48 177.709 433.743 178.444 433.743 179.352C433.743 180.259 434.48 180.995 435.388 180.995Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M395.329 137.694C395.004 137.694 394.686 137.79 394.416 137.971C394.145 138.151 393.934 138.408 393.81 138.708C393.685 139.008 393.653 139.339 393.716 139.657C393.78 139.976 393.936 140.269 394.166 140.499C394.396 140.728 394.689 140.885 395.009 140.948C395.328 141.012 395.658 140.979 395.959 140.855C396.259 140.73 396.516 140.52 396.697 140.25C396.878 139.979 396.974 139.662 396.974 139.337C396.974 138.901 396.801 138.483 396.492 138.175C396.184 137.867 395.766 137.694 395.329 137.694Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M475.437 137.694C475.111 137.694 474.794 137.79 474.523 137.971C474.253 138.151 474.042 138.408 473.917 138.708C473.793 139.008 473.76 139.339 473.824 139.657C473.887 139.976 474.044 140.269 474.274 140.499C474.504 140.728 474.797 140.885 475.116 140.948C475.435 141.012 475.766 140.979 476.066 140.855C476.367 140.73 476.624 140.52 476.804 140.25C476.985 139.979 477.082 139.662 477.082 139.337C477.082 138.901 476.908 138.483 476.6 138.175C476.291 137.867 475.873 137.694 475.437 137.694Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M497.64 297.522C505.571 263.013 483.995 228.615 449.448 220.692C414.901 212.77 380.466 234.322 372.534 268.831C364.603 303.34 386.179 337.738 420.726 345.66C455.273 353.583 489.708 332.031 497.64 297.522Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M435.107 330.823C461.434 330.823 482.776 309.504 482.776 283.206C482.776 256.908 461.434 235.589 435.107 235.589C408.78 235.589 387.438 256.908 387.438 283.206C387.438 309.504 408.78 330.823 435.107 330.823Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.107 323.824C457.565 323.824 475.77 305.639 475.77 283.206C475.77 260.773 457.565 242.588 435.107 242.588C412.65 242.588 394.444 260.773 394.444 283.206C394.444 305.639 412.65 323.824 435.107 323.824Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M435.107 291.276C439.569 291.276 443.186 287.663 443.186 283.206C443.186 278.749 439.569 275.137 435.107 275.137C430.646 275.137 427.029 278.749 427.029 283.206C427.029 287.663 430.646 291.276 435.107 291.276Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M437.741 228.092C437.743 227.645 437.613 227.208 437.366 226.835C437.119 226.463 436.767 226.172 436.354 226C435.941 225.827 435.487 225.781 435.048 225.867C434.609 225.953 434.205 226.167 433.889 226.482C433.572 226.797 433.355 227.199 433.267 227.637C433.179 228.075 433.223 228.53 433.394 228.943C433.565 229.355 433.854 229.709 434.226 229.957C434.598 230.205 435.035 230.338 435.482 230.338C435.778 230.339 436.072 230.282 436.346 230.17C436.62 230.058 436.869 229.892 437.079 229.684C437.289 229.475 437.455 229.227 437.569 228.954C437.683 228.681 437.741 228.388 437.741 228.092Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M437.741 337.561C437.741 337.115 437.609 336.679 437.361 336.308C437.112 335.937 436.759 335.648 436.347 335.477C435.934 335.306 435.48 335.261 435.041 335.348C434.603 335.435 434.201 335.65 433.885 335.966C433.569 336.281 433.354 336.684 433.267 337.121C433.179 337.559 433.224 338.013 433.395 338.425C433.566 338.837 433.856 339.19 434.227 339.438C434.599 339.686 435.035 339.818 435.482 339.818C436.081 339.818 436.656 339.58 437.08 339.157C437.503 338.734 437.741 338.16 437.741 337.561Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M380.682 285.078C381.924 285.078 382.93 284.072 382.93 282.832C382.93 281.591 381.924 280.586 380.682 280.586C379.44 280.586 378.433 281.591 378.433 282.832C378.433 284.072 379.44 285.078 380.682 285.078Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M490.282 285.078C491.524 285.078 492.531 284.072 492.531 282.832C492.531 281.591 491.524 280.586 490.282 280.586C489.04 280.586 488.034 281.591 488.034 282.832C488.034 284.072 489.04 285.078 490.282 285.078Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.664 150.526C119.696 125.352 104.156 100.061 78.9544 94.0358C53.7532 88.0107 28.4339 103.534 22.4023 128.707C16.3706 153.881 31.9106 179.172 57.1118 185.197C82.313 191.222 107.632 175.699 113.664 150.526Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0369 174.412C87.2804 174.412 102.88 158.83 102.88 139.607C102.88 120.385 87.2804 104.802 68.0369 104.802C48.7933 104.802 33.1934 120.385 33.1934 139.607C33.1934 158.83 48.7933 174.412 68.0369 174.412Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0371 169.296C84.4519 169.296 97.7587 156.004 97.7587 139.607C97.7587 123.21 84.4519 109.918 68.0371 109.918C51.6223 109.918 38.3154 123.21 38.3154 139.607C38.3154 156.004 51.6223 169.296 68.0371 169.296Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9401 139.607C73.9401 140.773 73.5939 141.913 72.9454 142.883C72.2968 143.853 71.3749 144.608 70.2963 145.055C69.2177 145.501 68.0309 145.618 66.8859 145.39C65.7409 145.163 64.6891 144.601 63.8636 143.776C63.0381 142.952 62.4759 141.901 62.2482 140.757C62.0204 139.614 62.1373 138.428 62.5841 137.351C63.0308 136.273 63.7874 135.353 64.7581 134.705C65.7288 134.057 66.87 133.711 68.0375 133.711C69.6029 133.711 71.1043 134.332 72.2113 135.438C73.3182 136.544 73.9401 138.043 73.9401 139.607Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9628 99.3217C69.9649 98.9942 69.8696 98.6735 69.6889 98.4003C69.5083 98.127 69.2505 97.9134 68.9482 97.7867C68.646 97.66 68.3128 97.6257 67.9911 97.6883C67.6693 97.751 67.3734 97.9076 67.1409 98.1384C66.9083 98.3693 66.7496 98.6638 66.6849 98.9849C66.6202 99.3059 66.6524 99.6389 66.7773 99.9416C66.9023 100.244 67.1145 100.503 67.3869 100.685C67.6593 100.867 67.9797 100.965 68.3076 100.965C68.7448 100.965 69.1642 100.792 69.4743 100.484C69.7845 100.176 69.9601 99.7584 69.9628 99.3217Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3079 180.995C69.2163 180.995 69.9528 180.259 69.9528 179.352C69.9528 178.444 69.2163 177.709 68.3079 177.709C67.3995 177.709 66.6631 178.444 66.6631 179.352C66.6631 180.259 67.3995 180.995 68.3079 180.995Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2591 137.694C27.9342 137.694 27.6166 137.79 27.3463 137.97C27.0761 138.15 26.8652 138.406 26.7405 138.706C26.6157 139.005 26.5825 139.335 26.6451 139.653C26.7077 139.972 26.8634 140.265 27.0924 140.495C27.3214 140.725 27.6135 140.882 27.9318 140.947C28.2502 141.012 28.5806 140.98 28.8813 140.858C29.1821 140.735 29.4397 140.526 29.6217 140.257C29.8036 139.988 29.9018 139.672 29.9039 139.347C29.9053 139.131 29.8637 138.916 29.7817 138.715C29.6997 138.515 29.5787 138.332 29.4258 138.179C29.273 138.025 29.0912 137.903 28.8909 137.82C28.6907 137.737 28.4759 137.694 28.2591 137.694Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.367 137.694C108.042 137.694 107.724 137.79 107.454 137.971C107.183 138.151 106.972 138.408 106.848 138.708C106.723 139.008 106.691 139.339 106.754 139.657C106.818 139.976 106.974 140.269 107.204 140.499C107.434 140.728 107.728 140.885 108.047 140.948C108.366 141.012 108.696 140.979 108.997 140.855C109.297 140.73 109.554 140.52 109.735 140.25C109.916 139.979 110.012 139.662 110.012 139.337C110.012 138.901 109.839 138.483 109.531 138.175C109.222 137.867 108.804 137.694 108.367 137.694Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.419 328.534C138.483 303.498 138.483 262.906 113.419 237.87C88.3549 212.833 47.7184 212.833 22.6546 237.87C-2.40929 262.906 -2.40929 303.498 22.6545 328.534C47.7184 353.571 88.3549 353.571 113.419 328.534Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0373 330.823C94.3642 330.823 115.706 309.504 115.706 283.206C115.706 256.908 94.3642 235.589 68.0373 235.589C41.7104 235.589 20.3682 256.908 20.3682 283.206C20.3682 309.504 41.7104 330.823 68.0373 330.823Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0374 323.824C90.4949 323.824 108.7 305.639 108.7 283.206C108.7 260.773 90.4949 242.588 68.0374 242.588C45.5799 242.588 27.3745 260.773 27.3745 283.206C27.3745 305.639 45.5799 323.824 68.0374 323.824Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0374 291.276C72.499 291.276 76.1159 287.663 76.1159 283.206C76.1159 278.75 72.499 275.137 68.0374 275.137C63.5758 275.137 59.959 278.75 59.959 283.206C59.959 287.663 63.5758 291.276 68.0374 291.276Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6609 228.092C70.6609 227.648 70.529 227.213 70.2819 226.844C70.0348 226.475 69.6836 226.187 69.2727 226.017C68.8619 225.847 68.4097 225.802 67.9735 225.889C67.5373 225.976 67.1367 226.189 66.8222 226.504C66.5077 226.818 66.2935 227.218 66.2068 227.654C66.12 228.089 66.1645 228.541 66.3347 228.951C66.5049 229.362 66.7932 229.713 67.1629 229.96C67.5327 230.206 67.9675 230.338 68.4122 230.338C68.7079 230.339 69.0009 230.282 69.2744 230.17C69.5478 230.057 69.7962 229.892 70.0053 229.683C70.2144 229.474 70.38 229.226 70.4925 228.953C70.605 228.68 70.6622 228.387 70.6609 228.092Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4122 339.808C69.6541 339.808 70.6609 338.802 70.6609 337.561C70.6609 336.321 69.6541 335.315 68.4122 335.315C67.1703 335.315 66.1636 336.321 66.1636 337.561C66.1636 338.802 67.1703 339.808 68.4122 339.808Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6119 285.078C14.8538 285.078 15.8606 284.072 15.8606 282.832C15.8606 281.591 14.8538 280.586 13.6119 280.586C12.37 280.586 11.3633 281.591 11.3633 282.832C11.3633 284.072 12.37 285.078 13.6119 285.078Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M123.212 280.575C122.765 280.573 122.327 280.704 121.954 280.951C121.582 281.197 121.29 281.549 121.118 281.961C120.945 282.373 120.899 282.827 120.985 283.266C121.071 283.704 121.285 284.107 121.601 284.424C121.916 284.74 122.319 284.956 122.757 285.044C123.196 285.132 123.651 285.088 124.064 284.918C124.477 284.747 124.831 284.458 125.08 284.087C125.328 283.715 125.461 283.279 125.461 282.832C125.462 282.536 125.405 282.243 125.293 281.969C125.18 281.695 125.015 281.447 124.806 281.237C124.597 281.027 124.349 280.861 124.075 280.747C123.802 280.634 123.509 280.575 123.212 280.575Z",
    stroke: "#252730",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1818_26502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 482,
    height: 424
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M84.4127 63.1751C84.4127 63.1751 -8.38538 167.622 9.03117 200.441C26.4477 233.26 106.951 193.443 101.017 208.49C95.0833 223.537 6.45981 315.381 38.6175 356.394C70.7751 397.408 210.253 312.032 200.093 348.948C189.932 385.865 191.431 430.424 250.729 422.625C310.026 414.826 373.197 293.054 369.012 317.596C364.827 342.137 351.834 429.436 409.716 405.176C467.598 380.915 496.768 269.293 484.171 191.997C471.575 114.702 435.149 154.207 420.772 151.441C406.395 148.675 458.718 42.6788 430.683 15.6208C402.647 -11.4373 268.458 87.779 253.613 93.1137C238.767 98.4484 289.508 5.4922 242.963 0.979058C196.418 -3.53408 146.75 5.97055 84.4127 63.1751Z",
    fill: "#252730"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1818_26502)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.107 -36.5692L52.8979 368.835H65.3633L329.045 -109.187L125.107 -36.5692Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.97 -108.274L65.0681 368.335H53.4949L125.548 -36.1956L327.97 -108.274Z",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.7373 222.028L81.4218 213.273",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5718 364.234L78.3902 229.323",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0747 342.347L279.857 -19.7334",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3843 365.356L76.9298 348.071",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.217 368.499L-18.5249 105.412L-17.065 215.855L401.815 367.937L450.217 368.499Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.5696 215.503L-18.0135 106.273L448.264 367.976L401.906 367.438L-16.5696 215.503Z",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.8233 239.986L8.20264 226.293",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.492 258.842L56.1548 243.69",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.536 298.574L131.509 270.964",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.815 367.938L212.814 300.482",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.045 300.033L278.173 271.3",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.351 369.621L334.436 303.064",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.201 370.295L524.896 104.627L478.179 -10.1931L446.623 369.172L459.201 370.295Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.163 368.718L478.504 -8.06778L524.372 104.664L458.818 369.758L447.163 368.718Z",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M470.656 79.9342L471.554 69.0471",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.8 303.064L470.206 85.4338",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.211 360.754L499.853 203.396",
    stroke: "#D3D3D3",
    strokeOpacity: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M426.746 322.57H302.501L314.992 367.446H469.202L426.746 322.57Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M352.341 353.224C352.542 349.243 344.592 345.607 334.583 345.102C324.574 344.597 316.296 347.415 316.095 351.397C315.894 355.378 323.845 359.014 333.854 359.519C343.863 360.024 352.14 357.206 352.341 353.224Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M442.432 345.167L441.606 342.238L440.317 342.156C433.536 334.757 415.953 328.718 395.011 327.412C374.069 326.107 355.869 329.924 348.216 336.426L346.083 336.29L345.021 340.479C344.656 341.286 344.438 342.152 344.376 343.036C343.732 353.373 365.355 363.121 392.678 364.798C420.002 366.476 442.659 359.503 443.304 349.166C443.363 347.78 443.063 346.402 442.432 345.167Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M441.578 342.205C442.199 332.229 421.318 322.812 394.939 321.173C368.559 319.533 346.67 326.292 346.049 336.268C345.428 346.245 366.309 355.661 392.688 357.301C419.068 358.94 440.957 352.182 441.578 342.205Z",
    fill: "#D53B5C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M367.288 352.92L392.841 338.203L351.012 344.985C354.734 348.059 360.362 350.789 367.288 352.92Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M392.841 338.203L430.795 329.725C424.731 326.596 416.497 324.048 407.02 322.516L392.841 338.203Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M441.578 342.205C442.199 332.229 421.318 322.812 394.939 321.173C368.559 319.533 346.67 326.292 346.049 336.268C345.428 346.245 366.309 355.661 392.688 357.301C419.068 358.94 440.957 352.182 441.578 342.205Z",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M409.145 338.928C408.945 342.129 401.883 344.287 393.477 343.761C385.071 343.235 378.345 340.225 378.544 337.024C378.744 333.823 385.752 331.665 394.203 332.191C402.654 332.717 409.336 335.737 409.145 338.928Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M366.444 322.96C356.985 324.973 350.022 328.401 347.308 332.663L390.59 336.825C393.822 336.181 391.906 334.83 391.906 334.83C391.906 334.83 396.627 335.319 397.489 334.023C398.115 333.089 377.745 326.524 366.444 322.96Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M392.841 338.203C392.601 338.203 392.37 338.107 392.199 337.937C392.029 337.767 391.934 337.537 391.934 337.296V334.83C391.934 334.583 392.032 334.347 392.206 334.172C392.381 333.998 392.617 333.9 392.864 333.9C393.111 333.9 393.347 333.998 393.522 334.172C393.696 334.347 393.795 334.583 393.795 334.83V337.296C393.795 337.419 393.77 337.541 393.721 337.654C393.673 337.767 393.602 337.869 393.513 337.954C393.424 338.039 393.318 338.104 393.203 338.147C393.087 338.19 392.964 338.209 392.841 338.203Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M456.992 359.494C456.874 360.926 453.96 361.851 450.484 361.579C447.007 361.307 444.275 359.92 444.384 358.487C444.492 357.054 447.415 356.13 450.892 356.411C454.369 356.692 457.101 358.07 456.992 359.494Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M346.845 349.737L338.285 349.302C337.037 349.078 335.775 348.932 334.509 348.866C333.238 348.802 331.964 348.82 330.696 348.921L321.283 348.449L321.437 353.681C321.292 356.692 326.884 359.421 333.937 359.784C340.99 360.146 346.827 357.97 346.981 354.969L346.845 349.737Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M346.845 349.737C346.691 352.747 340.854 354.905 333.801 354.552C326.748 354.198 321.156 351.46 321.301 348.449C321.446 345.439 327.301 343.281 334.355 343.634C341.408 343.988 347 346.726 346.845 349.737Z",
    fill: "#BABABA",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M333.392 344.895C333.185 344.915 332.977 344.862 332.803 344.747C332.629 344.631 332.501 344.46 332.439 344.261C332.377 344.062 332.386 343.848 332.464 343.654C332.542 343.461 332.684 343.3 332.866 343.199C334.591 342.011 339.338 338.502 340.509 336.507L341.526 334.748C343.614 331.121 345.411 328.093 346.401 327.041C347.39 325.989 349.714 324.937 351.348 324.221C351.82 324.012 352.256 323.84 352.51 323.695C352.731 323.584 352.988 323.566 353.223 323.644C353.458 323.722 353.652 323.891 353.763 324.112C353.873 324.333 353.891 324.589 353.813 324.824C353.735 325.059 353.566 325.253 353.345 325.363C353.036 325.517 352.601 325.708 352.092 325.925C350.685 326.542 348.561 327.467 347.762 328.319C346.963 329.172 344.612 333.134 343.142 335.682L342.161 337.45C340.536 340.171 334.228 344.55 333.992 344.704C333.821 344.837 333.608 344.905 333.392 344.895Z",
    fill: "#343643"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M349.668 324.484V325.808L352.936 327.512L359.636 324.266V322.543L349.668 324.484Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M349.668 324.484L353.073 325.699L359.636 322.543L355.741 321.21L349.668 324.484Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M335.861 342.537C334.155 340.823 331.549 340.642 330.052 342.129L325.386 345.756L331.568 351.967L335.607 348.803C335.833 348.666 336.043 348.505 336.233 348.322C337.731 346.853 337.568 344.251 335.861 342.537Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M331.204 346.192C332.911 347.905 333.074 350.508 331.568 351.995C330.061 353.482 327.465 353.31 325.758 351.587C324.051 349.864 323.888 347.271 325.386 345.783C326.884 344.296 329.498 344.469 331.204 346.192Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M309.891 327.639L314.62 340.851H320.112L314.838 327.639H309.891Z",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M313.013 328.818L316.989 340.098",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M317.743 331.72H312.795V334.621H317.961L317.743 331.72Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M302.501 322.57V344.088L314.856 383.078L314.992 367.446L302.501 322.57Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M443.757 382.326V386.579C443.757 388.592 447.579 390.206 452.299 390.206C457.02 390.206 460.832 388.573 460.832 386.579V382.326H443.757Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M452.299 385.971C457.017 385.971 460.841 384.339 460.841 382.326C460.841 380.313 457.017 378.681 452.299 378.681C447.582 378.681 443.757 380.313 443.757 382.326C443.757 384.339 447.582 385.971 452.299 385.971Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M315.891 382.326V386.579C315.891 388.592 319.712 390.206 324.433 390.206C329.153 390.206 332.966 388.573 332.966 386.579V382.326H315.891Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M324.433 385.971C329.15 385.971 332.975 384.339 332.975 382.326C332.975 380.313 329.15 378.681 324.433 378.681C319.715 378.681 315.891 380.313 315.891 382.326C315.891 384.339 319.715 385.971 324.433 385.971Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M314.856 383.078H466.215L469.202 367.446H314.992L314.856 383.078Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M88.407 322.57H212.652L200.152 367.446H45.9512L88.407 322.57Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7903 356.42C99.7903 360.409 91.6204 363.619 81.6351 363.592C71.6498 363.565 63.48 360.31 63.48 356.338C63.48 352.366 71.6498 349.138 81.6351 349.166C91.6204 349.193 99.7903 352.439 99.7903 356.42Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M186.417 364.145C186.535 365.569 189.449 366.503 192.926 366.222C196.403 365.941 199.135 364.562 199.017 363.139C198.899 361.715 195.994 360.772 192.508 361.053C189.023 361.334 186.299 362.685 186.417 364.145Z",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0715 353.192H85.5023C84.2416 353.022 82.9709 352.937 81.6988 352.938C80.4302 352.936 79.1629 353.015 77.9044 353.174H68.5L68.8994 358.396C68.8994 361.407 74.6092 363.837 81.6716 363.891C88.7339 363.946 94.4618 361.479 94.4709 358.451L94.0715 353.192Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0715 353.192C94.0715 356.202 88.3345 358.632 81.2721 358.632C74.2098 358.632 68.4909 356.157 68.5 353.137C68.5091 350.118 74.237 347.697 81.2994 347.697C88.3617 347.697 94.0806 350.172 94.0715 353.192Z",
    fill: "#BABABA",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.355 348.068C80.355 348.068 86.5186 343.39 87.9347 340.706C89.3508 338.022 96.1046 331.33 100.707 327.848C102.141 326.769 116.584 323.958 117.782 323.314",
    stroke: "#343643",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.219 321.437L116.956 322.734L119.806 325.055L127.023 323.214L127.368 321.528L117.219 321.437Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.219 321.437L120.306 323.305L127.368 321.528L123.828 319.442L117.219 321.437Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7518 346.518C80.9363 344.886 78.3582 344.831 76.933 346.391L72.4487 350.263L78.912 356.175L82.7972 352.82C83.0173 352.673 83.2185 352.499 83.3963 352.303C84.8305 350.743 84.54 348.177 82.7518 346.518Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2765 350.39C80.0921 352.022 80.3553 354.615 78.9211 356.175C77.4868 357.735 74.8815 357.68 73.0933 356.048C71.305 354.416 71.0236 351.822 72.4487 350.263C73.8739 348.703 76.4883 348.758 78.2765 350.39Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M212.652 322.57V344.088L200.297 383.078L200.152 367.446L212.652 322.57Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M187.189 382.326V386.579C187.189 388.592 191.02 390.206 195.731 390.206C200.442 390.206 204.273 388.573 204.273 386.579V382.326H187.189Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M195.731 385.971C200.449 385.971 204.273 384.339 204.273 382.326C204.273 380.313 200.449 378.681 195.731 378.681C191.013 378.681 187.189 380.313 187.189 382.326C187.189 384.339 191.013 385.971 195.731 385.971Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0527 382.326V386.579C51.0527 388.592 54.8744 390.206 59.5856 390.206C64.2969 390.206 68.1276 388.573 68.1276 386.579V382.326H51.0527Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5854 385.971C64.3031 385.971 68.1274 384.339 68.1274 382.326C68.1274 380.313 64.3031 378.681 59.5854 378.681C54.8678 378.681 51.0435 380.313 51.0435 382.326C51.0435 384.339 54.8678 385.971 59.5854 385.971Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M200.297 383.078H48.9377L45.9512 367.446H200.152L200.297 383.078Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M212.652 322.57H302.284L309.682 347.987H205.653L212.652 322.57Z",
    fill: "#B8B8B8",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M309.673 347.987H205.653V372.732H309.673V347.987Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M227.938 323.078L226.241 347.307",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M285.762 322.87L291.272 347.416",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M240.538 329.743L240.756 345.611",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M256.959 329.743L258.757 346.355",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M273.798 329.643L277.084 345.72",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M268.079 344.958C267.838 344.958 267.607 344.863 267.437 344.693C267.267 344.523 267.171 344.292 267.171 344.052V340.352C267.171 340.111 267.267 339.881 267.437 339.711C267.607 339.541 267.838 339.445 268.079 339.445C268.32 339.445 268.551 339.541 268.721 339.711C268.891 339.881 268.987 340.111 268.987 340.352V344.052C268.987 344.292 268.891 344.523 268.721 344.693C268.551 344.863 268.32 344.958 268.079 344.958Z",
    fill: "#343643"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 329.045L233.013 344.55",
    stroke: "#343643",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M234.701 337.478H231.633L231.17 339.581L231.46 345.04L234.52 345.103L235.137 341.875L234.701 337.478Z",
    fill: "#343643"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M232.713 337.478L232.35 339.554C232.308 339.619 232.286 339.694 232.287 339.772L232.559 344.079C232.558 344.139 232.569 344.2 232.591 344.256C232.613 344.313 232.646 344.365 232.688 344.408C232.73 344.452 232.781 344.487 232.836 344.512C232.892 344.536 232.952 344.549 233.013 344.55C233.137 344.548 233.255 344.499 233.344 344.413C233.434 344.328 233.487 344.211 233.494 344.088L233.213 339.899L233.766 337.478H232.713Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M280.67 329.045L283.538 344.55",
    stroke: "#343643",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M280.888 337.478H283.956L284.7 339.581L285.163 345.04L282.113 345.103L281.051 341.875L280.888 337.478Z",
    fill: "#343643"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M282.876 337.478L283.529 339.554C283.575 339.619 283.606 339.694 283.62 339.772L283.929 344.079C283.941 344.136 283.94 344.196 283.926 344.253C283.912 344.31 283.886 344.364 283.848 344.409C283.81 344.454 283.763 344.491 283.709 344.515C283.656 344.54 283.597 344.552 283.539 344.55C283.409 344.545 283.285 344.496 283.187 344.413C283.088 344.329 283.02 344.214 282.994 344.088L282.712 339.899L281.805 337.478H282.876Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M243.234 340.706H255.57",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M262.125 340.706H274.461",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M249.752 344.958C249.511 344.958 249.28 344.863 249.11 344.693C248.939 344.523 248.844 344.292 248.844 344.052V340.352C248.844 340.111 248.939 339.881 249.11 339.711C249.28 339.541 249.511 339.445 249.752 339.445C249.992 339.445 250.223 339.541 250.393 339.711C250.564 339.881 250.659 340.111 250.659 340.352V344.052C250.659 344.292 250.564 344.523 250.393 344.693C250.223 344.863 249.992 344.958 249.752 344.958Z",
    fill: "#343643"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M217.78 333.923L216.963 341.123",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M223.263 333.823L222.955 340.923",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M223.726 345.384H215.103L215.375 343.362H224.008L223.726 345.384Z",
    stroke: "#343643",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M225.76 328.446H217.127L217.408 326.415H226.041L225.76 328.446Z",
    stroke: "#343643",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M299.688 333.923L301.43 341.123",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M294.195 333.823L295.412 340.923",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M295.212 345.384H303.845L303.3 343.362H294.677L295.212 345.384Z",
    stroke: "#343643",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M291 328.446H299.633L299.097 326.415H290.464L291 328.446Z",
    stroke: "#343643",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M276.349 359.466C277.717 359.466 278.827 358.358 278.827 356.991C278.827 355.624 277.717 354.516 276.349 354.516C274.98 354.516 273.871 355.624 273.871 356.991C273.871 358.358 274.98 359.466 276.349 359.466Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M276.848 356.991C276.848 357.123 276.796 357.25 276.702 357.344C276.608 357.437 276.481 357.49 276.349 357.49C276.277 357.499 276.204 357.494 276.135 357.473C276.065 357.452 276.001 357.416 275.947 357.369C275.892 357.321 275.848 357.262 275.818 357.196C275.788 357.13 275.773 357.059 275.773 356.986C275.773 356.914 275.788 356.842 275.818 356.777C275.848 356.711 275.892 356.652 275.947 356.604C276.001 356.557 276.065 356.521 276.135 356.5C276.204 356.479 276.277 356.474 276.349 356.483C276.415 356.483 276.481 356.496 276.542 356.522C276.603 356.548 276.659 356.585 276.705 356.632C276.752 356.68 276.788 356.736 276.813 356.797C276.838 356.859 276.85 356.925 276.848 356.991Z",
    fill: "#343643"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M260.164 355.268C261.823 355.268 263.169 353.924 263.169 352.267C263.169 350.609 261.823 349.265 260.164 349.265C258.504 349.265 257.159 350.609 257.159 352.267C257.159 353.924 258.504 355.268 260.164 355.268Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M260.772 352.267C260.772 352.428 260.707 352.582 260.593 352.696C260.479 352.81 260.325 352.874 260.163 352.874C260.002 352.874 259.847 352.81 259.733 352.696C259.619 352.582 259.555 352.428 259.555 352.267C259.555 352.106 259.619 351.951 259.733 351.837C259.847 351.723 260.002 351.659 260.163 351.659C260.325 351.659 260.479 351.723 260.593 351.837C260.707 351.951 260.772 352.106 260.772 352.267Z",
    fill: "#343643"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M217.599 352.267C217.599 352.861 217.422 353.441 217.092 353.935C216.761 354.429 216.291 354.814 215.742 355.041C215.192 355.267 214.588 355.326 214.004 355.21C213.421 355.093 212.886 354.806 212.466 354.386C212.046 353.965 211.761 353.43 211.646 352.847C211.531 352.264 211.592 351.66 211.821 351.112C212.05 350.564 212.436 350.095 212.931 349.767C213.427 349.438 214.008 349.264 214.603 349.265C214.997 349.265 215.388 349.343 215.752 349.494C216.116 349.645 216.446 349.866 216.725 350.145C217.003 350.424 217.223 350.755 217.373 351.119C217.523 351.483 217.6 351.873 217.599 352.267Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M215.212 352.267C215.212 352.428 215.147 352.582 215.033 352.696C214.919 352.81 214.765 352.874 214.603 352.874C214.442 352.874 214.287 352.81 214.173 352.696C214.059 352.582 213.995 352.428 213.995 352.267C213.995 352.106 214.059 351.951 214.173 351.837C214.287 351.723 214.442 351.659 214.603 351.659C214.765 351.659 214.919 351.723 215.033 351.837C215.147 351.951 215.212 352.106 215.212 352.267Z",
    fill: "#343643"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M248.662 365.569C248.662 365.865 248.574 366.154 248.41 366.4C248.245 366.646 248.011 366.838 247.737 366.951C247.464 367.064 247.163 367.094 246.872 367.036C246.582 366.979 246.315 366.836 246.105 366.627C245.896 366.418 245.753 366.151 245.695 365.861C245.637 365.571 245.667 365.27 245.781 364.996C245.894 364.723 246.086 364.489 246.332 364.325C246.578 364.161 246.868 364.073 247.164 364.073C247.361 364.073 247.556 364.111 247.737 364.187C247.919 364.262 248.084 364.372 248.223 364.511C248.362 364.65 248.473 364.815 248.548 364.996C248.623 365.178 248.662 365.372 248.662 365.569Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M247.437 365.569C247.445 365.613 247.443 365.659 247.431 365.702C247.419 365.745 247.398 365.786 247.369 365.82C247.34 365.855 247.304 365.882 247.263 365.901C247.222 365.92 247.178 365.93 247.133 365.93C247.088 365.93 247.043 365.92 247.003 365.901C246.962 365.882 246.926 365.855 246.897 365.82C246.868 365.786 246.847 365.745 246.835 365.702C246.823 365.659 246.821 365.613 246.829 365.569C246.841 365.497 246.879 365.433 246.934 365.386C246.99 365.339 247.06 365.313 247.133 365.313C247.206 365.313 247.276 365.339 247.332 365.386C247.387 365.433 247.425 365.497 247.437 365.569Z",
    fill: "#343643"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M253.128 365.569C253.128 365.865 253.041 366.154 252.876 366.4C252.711 366.646 252.477 366.838 252.204 366.951C251.93 367.064 251.629 367.094 251.338 367.036C251.048 366.979 250.781 366.836 250.572 366.627C250.362 366.418 250.219 366.151 250.162 365.861C250.104 365.571 250.133 365.27 250.247 364.996C250.36 364.723 250.552 364.489 250.798 364.325C251.045 364.161 251.334 364.073 251.631 364.073C252.028 364.073 252.409 364.23 252.69 364.511C252.971 364.792 253.128 365.172 253.128 365.569Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M251.93 365.569C251.932 365.631 251.915 365.691 251.882 365.743C251.849 365.796 251.801 365.836 251.744 365.861C251.687 365.885 251.624 365.892 251.564 365.881C251.503 365.869 251.447 365.839 251.403 365.796C251.36 365.752 251.33 365.696 251.318 365.636C251.307 365.575 251.314 365.512 251.338 365.456C251.363 365.399 251.404 365.351 251.456 365.318C251.508 365.285 251.569 365.268 251.631 365.27C251.709 365.272 251.784 365.304 251.84 365.36C251.896 365.415 251.928 365.49 251.93 365.569Z",
    fill: "#343643"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M248.662 360.237C248.662 360.533 248.574 360.822 248.41 361.068C248.245 361.314 248.011 361.506 247.737 361.619C247.464 361.733 247.163 361.762 246.872 361.705C246.582 361.647 246.315 361.504 246.105 361.295C245.896 361.086 245.753 360.819 245.695 360.529C245.637 360.239 245.667 359.938 245.781 359.665C245.894 359.391 246.086 359.158 246.332 358.993C246.578 358.829 246.868 358.741 247.164 358.741C247.361 358.741 247.556 358.78 247.737 358.855C247.919 358.93 248.084 359.04 248.223 359.179C248.362 359.318 248.473 359.483 248.548 359.665C248.623 359.846 248.662 360.041 248.662 360.237Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M247.437 360.237C247.445 360.281 247.443 360.327 247.431 360.37C247.419 360.414 247.398 360.454 247.369 360.488C247.34 360.523 247.304 360.55 247.263 360.569C247.222 360.588 247.178 360.598 247.133 360.598C247.088 360.598 247.043 360.588 247.003 360.569C246.962 360.55 246.926 360.523 246.897 360.488C246.868 360.454 246.847 360.414 246.835 360.37C246.823 360.327 246.821 360.281 246.829 360.237C246.841 360.166 246.879 360.101 246.934 360.054C246.99 360.007 247.06 359.982 247.133 359.982C247.206 359.982 247.276 360.007 247.332 360.054C247.387 360.101 247.425 360.166 247.437 360.237Z",
    fill: "#343643"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M253.128 360.237C253.128 360.533 253.041 360.822 252.876 361.068C252.711 361.314 252.477 361.506 252.204 361.619C251.93 361.733 251.629 361.762 251.338 361.705C251.048 361.647 250.781 361.504 250.572 361.295C250.362 361.086 250.219 360.819 250.162 360.529C250.104 360.239 250.133 359.938 250.247 359.665C250.36 359.391 250.552 359.158 250.798 358.993C251.045 358.829 251.334 358.741 251.631 358.741C252.028 358.741 252.409 358.899 252.69 359.179C252.971 359.46 253.128 359.84 253.128 360.237Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M251.93 360.237C251.932 360.299 251.915 360.36 251.882 360.412C251.849 360.464 251.801 360.505 251.744 360.529C251.687 360.554 251.624 360.56 251.564 360.549C251.503 360.537 251.447 360.508 251.403 360.464C251.36 360.42 251.33 360.365 251.318 360.304C251.307 360.243 251.314 360.181 251.338 360.124C251.363 360.067 251.404 360.019 251.456 359.986C251.508 359.953 251.569 359.936 251.631 359.938C251.709 359.94 251.784 359.972 251.84 360.028C251.896 360.084 251.928 360.158 251.93 360.237Z",
    fill: "#343643"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M299.533 366.938C300.902 366.938 302.011 365.83 302.011 364.463C302.011 363.095 300.902 361.987 299.533 361.987C298.164 361.987 297.055 363.095 297.055 364.463C297.055 365.83 298.164 366.938 299.533 366.938Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M300.032 364.499C300.034 364.565 300.022 364.631 299.997 364.693C299.972 364.754 299.936 364.81 299.889 364.857C299.843 364.905 299.788 364.942 299.726 364.968C299.665 364.994 299.599 365.007 299.533 365.007C299.461 365.016 299.388 365.011 299.319 364.99C299.249 364.969 299.185 364.933 299.131 364.886C299.076 364.838 299.032 364.779 299.002 364.713C298.973 364.647 298.957 364.576 298.957 364.504C298.957 364.431 298.973 364.36 299.002 364.294C299.032 364.228 299.076 364.169 299.131 364.121C299.185 364.074 299.249 364.038 299.319 364.017C299.388 363.996 299.461 363.991 299.533 364C299.666 364 299.793 364.053 299.886 364.146C299.98 364.24 300.032 364.367 300.032 364.499Z",
    fill: "#343643"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M285.127 358.732C284.802 358.732 284.479 358.796 284.179 358.92C283.878 359.045 283.605 359.227 283.375 359.457C283.145 359.687 282.962 359.96 282.838 360.26C282.713 360.56 282.649 360.882 282.649 361.207C282.653 361.46 282.696 361.711 282.776 361.951C282.758 362.077 282.758 362.205 282.776 362.332C283.449 363.032 284.074 363.777 284.646 364.562C285.154 365.36 285.654 366.149 286.38 366.004C287.106 365.859 287.605 365.569 287.605 364.853C287.605 364.136 287.605 361.226 287.605 361.226C287.608 360.899 287.545 360.575 287.422 360.273C287.298 359.97 287.116 359.695 286.886 359.463C286.656 359.232 286.382 359.048 286.08 358.922C285.778 358.797 285.454 358.732 285.127 358.732Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M266.191 360.582C266.196 360.04 265.987 359.519 265.61 359.13C265.233 358.742 264.718 358.517 264.176 358.505C263.83 358.503 263.488 358.574 263.172 358.714C262.857 358.854 262.574 359.059 262.344 359.316C262.114 359.574 261.941 359.877 261.838 360.206C261.734 360.535 261.702 360.883 261.743 361.226C261.897 361.888 262.288 364.154 262.978 364.952C263.667 365.75 263.368 367.419 264.366 367.555C264.558 367.573 264.751 367.55 264.933 367.488C265.115 367.425 265.281 367.324 265.421 367.192C265.56 367.059 265.669 366.898 265.741 366.72C265.813 366.542 265.846 366.35 265.837 366.158C265.755 365.623 265.683 365.025 265.683 365.025C266.125 364.474 266.368 363.79 266.373 363.084C266.3 362.051 266.191 360.582 266.191 360.582Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M299.079 349.574H279.925V357.517H299.079V349.574Z",
    stroke: "#343643",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M100.508 345.167L101.334 342.238L102.614 342.156C109.395 334.757 127.023 328.718 147.902 327.412C168.78 326.107 187.044 329.924 194.687 336.426L196.83 336.29L197.883 340.479C198.247 341.286 198.466 342.152 198.527 343.036C199.172 353.373 177.549 363.121 150.235 364.798C122.92 366.476 100.244 359.503 99.5998 349.166C99.5477 347.776 99.8607 346.398 100.508 345.167Z",
    fill: "#343643",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M150.186 357.337C176.566 355.698 197.447 346.281 196.826 336.305C196.204 326.328 174.316 319.57 147.936 321.209C121.556 322.848 100.675 332.265 101.296 342.241C101.918 352.218 123.806 358.976 150.186 357.337Z",
    fill: "#D53B5C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M175.642 352.92L150.098 338.203L191.919 344.985C188.206 348.059 182.569 350.789 175.642 352.92Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 338.203L112.136 329.752C118.2 326.624 126.442 324.076 135.91 322.543L150.098 338.203Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M150.186 357.337C176.566 355.698 197.447 346.281 196.826 336.305C196.204 326.328 174.316 319.57 147.936 321.209C121.556 322.848 100.675 332.265 101.296 342.241C101.918 352.218 123.806 358.976 150.186 357.337Z",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M133.795 338.928C133.995 342.129 141.002 344.287 149.454 343.761C157.905 343.235 164.595 340.225 164.395 337.024C164.196 333.823 157.179 331.665 148.727 332.191C140.276 332.717 133.595 335.737 133.795 338.928Z",
    fill: "white",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 338.203C150.339 338.203 150.57 338.107 150.74 337.937C150.91 337.767 151.006 337.537 151.006 337.296V334.83C151.006 334.589 150.91 334.359 150.74 334.189C150.57 334.019 150.339 333.923 150.098 333.923C149.857 333.923 149.627 334.019 149.456 334.189C149.286 334.359 149.19 334.589 149.19 334.83V337.296C149.19 337.537 149.286 337.767 149.456 337.937C149.627 338.107 149.857 338.203 150.098 338.203Z",
    fill: "#525460",
    stroke: "#343643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M212.806 322.788C212.806 322.788 212.006 315.824 216.511 304.569C220.917 293.314 232.864 273.643 232.864 273.643C232.864 273.643 262.828 286.953 275.069 287.931C287.309 288.91 307.775 286.953 307.775 286.953C307.775 286.953 312.573 313.867 313.944 317.586C315.315 321.305 315.836 322.788 315.836 322.788H212.806Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M273.697 304.863C294.359 306.331 305.718 303.884 310.614 302.318C309.145 294.586 307.775 286.855 307.775 286.855C307.775 286.855 287.309 288.91 275.068 287.833C262.828 286.855 232.863 273.545 232.863 273.545C232.863 273.545 229.436 279.221 225.617 286.268C231.688 290.965 250 303.297 273.697 304.863Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M324.519 167.651C324.519 167.651 328.143 159.919 332.941 153.558C337.739 147.196 343.614 144.456 344.789 141.911C345.965 139.367 359.086 110.495 359.086 110.495C359.086 110.495 347.433 95.7171 339.012 86.4195C330.591 77.122 316.294 64.7905 316.294 64.7905C316.294 64.7905 298.57 58.6248 296.024 55.8845C293.478 53.1442 290.344 48.6422 288.484 47.4678C286.623 46.2934 283.686 45.9019 285.252 44.5317C286.819 43.1616 289.757 42.2807 291.617 43.8466C293.478 45.4125 299.353 49.523 299.353 49.523C299.353 49.523 293.87 23.7835 292.499 20.8475C291.128 17.9114 292.009 16.737 292.792 16.3455C293.478 15.954 295.436 17.3242 295.436 17.3242C295.436 17.3242 294.947 14.1924 296.611 13.8009C298.276 13.4095 299.255 14.486 299.549 15.8562C299.745 17.2263 305.522 32.1024 305.522 32.1024C305.522 32.1024 315.119 33.2768 317.763 35.3321C320.407 37.3873 321.973 42.7701 322.953 46.7827C323.736 50.0124 324.519 53.9271 324.519 53.9271C324.519 53.9271 334.997 63.3225 346.258 69.1946C357.617 75.0668 381.608 93.4661 384.154 96.0107C386.7 98.5553 386.7 100.415 386.015 102.568C385.33 104.721 376.125 134.767 372.11 146.902C368.095 159.038 346.65 188.595 345.965 189.867C345.377 191.041 344.3 201.22 336.27 218.249C331.472 228.329 327.359 233.125 327.359 233.125C327.359 233.125 319.134 213.355 321.386 197.305C323.932 181.254 324.519 167.651 324.519 167.651Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M343.125 149.251L340.383 167.357",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M295.632 17.4221C295.632 17.4221 297.003 20.6518 298.472 25.4474C299.941 30.2429 301.41 36.898 301.41 36.898",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M298.864 38.0723L303.662 35.6256",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M306.404 33.7661C306.404 33.7661 306.893 30.5364 308.558 29.8514C310.125 29.1663 312.965 30.2428 313.454 31.3194C313.944 32.4938 314.825 36.0171 314.825 40.6169C314.825 45.2168 315.706 46.5869 314.238 46.5869C312.769 46.5869 311.79 45.2168 311.496 43.3573C311.202 41.4978 309.341 35.9192 309.341 35.9192C309.341 35.9192 308.068 36.8979 307.187 36.4086",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M306.404 33.7661C306.404 33.7661 306.893 30.5364 308.558 29.8514C310.125 29.1663 312.965 30.2428 313.454 31.3194C313.944 32.4938 314.825 36.0171 314.825 40.6169C314.825 45.2168 315.706 46.5869 314.238 46.5869C312.769 46.5869 311.79 45.2168 311.496 43.3573C311.202 41.4977 309.341 35.9192 309.341 35.9192C309.341 35.9192 308.068 36.8979 307.187 36.4086",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M309.341 35.9193L308.656 32.8854",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M314.14 32.2003C314.14 32.2003 317.665 31.6131 318.644 32.2982C319.623 32.9832 319.917 34.9406 319.917 37.2895C319.917 39.6383 320.211 47.0764 319.525 47.37C318.84 47.7614 317.077 47.1742 316.588 45.9019C316.196 44.6296 314.336 33.7662 314.336 33.7662L314.14 32.2003Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M300.92 49.3273C300.92 49.3273 303.172 48.9359 304.249 48.7401C306.599 48.2508 310.321 48.3486 311.887 51.1868",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M248.335 176.85C248.335 176.85 226.597 187.42 222.386 196.522C218.175 205.624 218.959 214.921 217.979 216.879C217 218.836 199.864 263.856 199.864 263.856C199.864 263.856 183.021 272.272 176.558 274.915C170.193 277.655 160.009 282.842 158.834 284.995C157.561 287.246 145.32 301.046 139.151 305.646C132.982 310.343 128.086 311.322 129.261 313.084C130.534 314.845 132.786 312.594 133.766 312.301C134.745 312.007 142.97 308.19 142.97 308.19C142.97 308.19 137.193 313.964 135.039 315.726C132.884 317.586 132.101 318.662 132.688 319.347C133.374 320.032 134.843 319.641 135.822 319.151C136.801 318.662 145.908 311.713 145.908 311.713C145.908 311.713 137.976 322.87 136.997 323.849C136.018 324.828 138.466 325.513 139.641 325.317C140.816 325.121 147.377 319.543 147.377 319.543C147.377 319.543 142.97 325.024 143.558 325.513C144.243 326.002 145.516 326.002 146.691 325.219C147.866 324.436 155.113 315.335 155.896 314.062C156.68 312.79 162.359 306.037 162.359 306.037C162.359 306.037 163.045 310.833 165.688 311.811C168.332 312.79 173.914 308.973 173.718 304.569C173.522 300.165 172.445 299.676 172.543 299.088C172.739 298.599 174.208 291.063 174.208 291.063C174.208 291.063 194.967 293.314 201.137 290.77C209.068 287.442 215.727 280.885 215.727 280.885L225.128 263.171C228.947 255.83 232.08 248.197 234.332 240.171L238.641 225.002C238.641 225.002 252.448 200.339 253.623 189.769C254.798 179.395 250.979 175.284 248.335 176.85Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M173.718 294.195L174.697 285.191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M173.718 301.927C173.718 301.927 173.033 298.795 170.389 301.242C167.745 303.688 166.08 306.722 166.08 306.722",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M147.475 319.739C147.475 319.739 152.567 310.148 154.917 305.743",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M146.006 311.811L151.392 304.471",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M143.068 308.19L148.16 302.416",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M199.864 263.856C199.864 263.856 204.564 266.009 205.152 270.119",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M264.003 171.467C264.003 171.467 246.475 208.755 241.383 221.283C236.291 233.712 233.941 257.788 229.338 265.226C224.736 272.566 224.736 272.566 224.736 272.566C224.736 272.566 243.047 289.399 272.62 292.727C302.193 296.054 326.869 288.91 326.869 288.91C326.869 288.91 326.086 268.553 328.632 261.702C331.178 254.852 332.451 244.086 330.884 233.223C329.318 222.261 319.427 185.071 310.516 169.804C301.605 154.536 293.967 150.23 293.967 150.23C293.967 150.23 277.223 164.812 264.003 171.467Z",
    fill: "#76CCCC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M260.478 282.744C260.478 282.744 280.062 267.77 287.504 261.115",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M291.324 259.549C291.324 259.549 284.959 265.911 277.027 273.545",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M305.914 162.268C299.157 152.872 294.163 150.034 294.163 150.034C294.163 150.034 277.32 164.812 264.101 171.467C264.101 171.467 262.926 179.982 260.478 189.377C263.219 192.216 268.703 195.739 278.887 194.662C295.632 192.803 303.172 172.153 305.914 162.268Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M237.466 112.844C237.466 112.844 230.22 123.414 225.911 137.213C221.7 151.013 220.134 158.157 231.101 168.042C242.068 178.025 239.816 190.748 240.306 195.25C240.795 199.752 238.739 214.628 232.962 227.84C227.184 241.052 227.87 245.554 227.87 245.554L235.605 249.077L238.641 241.737L238.347 250.056C238.347 250.056 242.264 250.741 245.496 252.992C248.825 255.243 259.597 256.907 259.597 256.907L258.03 246.435L261.457 256.515C261.457 256.515 264.297 257.886 266.549 258.375C268.801 258.864 273.306 259.452 273.306 259.452C273.306 259.452 267.528 253.677 265.668 240.661C263.905 227.742 268.801 217.466 270.76 198.773C272.718 180.08 271.151 177.242 271.151 177.242L286.232 156.298L288.19 162.659C288.19 162.659 290.051 173.229 291.128 188.986C292.205 204.743 291.226 221.674 296.514 234.104C301.801 246.533 314.042 255.635 314.042 255.635L321.19 244.576L316.979 238.214L323.932 242.814C323.932 242.814 328.632 234.495 330.297 229.699C331.962 224.904 333.822 218.347 333.822 218.347L328.436 206.407C328.436 206.407 331.57 208.658 331.962 209.343C332.353 210.028 330.689 197.599 328.828 184.973C326.968 172.348 325.597 165.693 325.597 165.693C325.597 165.693 318.35 164.91 315.315 158.842C312.279 152.775 310.125 132.712 305.033 123.023C299.941 113.334 298.57 108.049 289.659 103.645C280.748 99.2404 269.878 96.7937 258.813 97.9681C247.846 99.1425 236.976 111.963 236.976 111.963",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M237.466 112.844C237.466 112.844 230.22 123.414 225.911 137.213C221.7 151.013 220.134 158.157 231.101 168.042C242.068 178.025 239.816 190.748 240.306 195.25C240.795 199.752 238.739 214.628 232.962 227.84C227.184 241.052 227.87 245.554 227.87 245.554L235.605 249.077L238.641 241.737L238.347 250.056C238.347 250.056 242.264 250.741 245.496 252.992C248.825 255.243 259.597 256.907 259.597 256.907L258.03 246.435L261.457 256.515C261.457 256.515 264.297 257.886 266.549 258.375C268.801 258.864 273.306 259.452 273.306 259.452C273.306 259.452 267.528 253.677 265.668 240.661C263.905 227.742 268.801 217.466 270.76 198.773C272.718 180.08 271.151 177.242 271.151 177.242L286.232 156.298L288.19 162.659C288.19 162.659 290.051 173.229 291.128 188.986C292.205 204.743 291.226 221.674 296.514 234.104C301.801 246.533 314.042 255.635 314.042 255.635L321.19 244.576L316.979 238.214L323.932 242.814C323.932 242.814 328.632 234.495 330.297 229.699C331.962 224.904 333.822 218.347 333.822 218.347L328.436 206.407C328.436 206.407 331.57 208.658 331.962 209.343C332.353 210.028 330.689 197.599 328.828 184.973C326.968 172.348 325.597 165.693 325.597 165.693C325.597 165.693 318.35 164.91 315.315 158.842C312.279 152.775 310.125 132.712 305.033 123.023C299.941 113.334 298.57 108.049 289.659 103.645C280.748 99.2404 269.878 96.7937 258.813 97.9681C247.846 99.1425 236.976 111.963 236.976 111.963",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M237.172 131.928C237.172 131.928 242.166 142.694 242.656 147.49C243.146 152.285 245.692 162.072 249.707 167.357C253.819 172.642 264.003 180.863 266.353 182.037C268.704 183.212 271.25 183.212 273.404 181.548C275.558 179.884 287.505 165.302 288.288 162.561C289.072 159.723 288.484 151.404 285.742 140.247C283 128.992 269.193 121.163 266.647 119.793C264.101 118.423 277.419 103.547 274.481 105.895C271.641 108.342 265.178 116.955 264.101 117.542C263.024 118.227 248.923 120.771 243.537 124.882C238.25 129.09 237.172 131.928 237.172 131.928Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M254.603 146.707C254.603 146.707 248.727 145.336 245.104 145.826C241.481 146.315 239.914 149.251 240.893 151.698C241.971 154.243 244.517 157.668 247.258 158.549C250 159.43 253.917 158.255 255.288 154.243C256.659 150.23 256.169 147.881 254.603 146.707Z",
    fill: "#76CCCC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M255.288 154.243C255.973 152.089 256.169 150.426 255.973 149.153C249.119 148.86 245.006 152.481 242.95 155.123C244.125 156.689 245.692 158.059 247.258 158.549C250.098 159.527 254.015 158.255 255.288 154.243Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M261.359 144.847C261.359 144.847 265.276 142.988 273.698 140.737C281.238 138.779 281.825 144.064 281.238 147C280.65 149.936 278.398 152.872 274.971 154.732C271.543 156.591 265.962 156.591 262.926 152.872C259.891 149.153 259.695 146.511 261.359 144.847Z",
    fill: "#76CCCC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M262.437 152.187C262.632 152.383 262.828 152.677 262.926 152.872C265.962 156.591 271.543 156.591 274.971 154.732C278.398 152.872 280.65 149.936 281.238 147C281.336 146.315 281.434 145.532 281.336 144.651C273.11 144.847 265.178 150.132 262.437 152.187Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M280.258 141.324L286.819 133.69",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M254.603 146.707L260.674 145.141",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M255.974 148.273C255.974 148.273 258.52 146.413 259.988 147.587",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M262.73 142.596C262.73 142.596 267.627 136.92 274.873 138.877",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M253.721 145.141C253.721 145.141 245.985 141.128 243.439 144.554",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M264.101 163.834C261.653 165.4 258.324 165.4 257.345 165.008C256.365 164.519 257.051 160.213 257.051 160.213C257.051 160.213 257.051 156.004 256.659 152.481",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M259.009 169.412C259.009 169.412 266.158 171.761 273.208 162.561",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M300.306 147.983C307.877 147.862 313.897 140.448 313.754 131.422C313.61 122.397 307.357 115.177 299.786 115.298C292.215 115.418 286.195 122.832 286.338 131.858C286.482 140.884 292.735 148.103 300.306 147.983Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M313.748 132.32C313.846 140.15 308.852 146.511 302.487 146.609C296.122 146.707 290.932 140.443 290.834 132.712C290.736 124.882 295.73 118.521 302.095 118.423C308.46 118.227 313.65 124.491 313.748 132.32Z",
    fill: "#76CCCC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M308.558 132.516C308.558 134.571 307.285 136.235 305.62 136.235C303.955 136.235 302.584 134.669 302.584 132.614C302.584 130.558 303.857 128.895 305.522 128.895C307.187 128.895 308.558 130.558 308.558 132.516Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M237.466 112.844C237.466 112.844 244.32 102.372 260.772 100.121C277.223 97.8702 293.869 110.397 294.947 111.474C295.926 112.648 301.116 113.236 301.899 111.376C302.683 109.517 299.255 103.644 288.582 98.8489C277.908 94.0533 264.297 93.0746 252.742 96.9894C241.089 100.904 234.626 110.985 237.466 112.844Z",
    fill: "#919191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M295.828 112.453L295.436 116.367",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M301.899 111.474L301.507 115.095",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1818_26502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 424,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjd);
export default __webpack_public_path__ + "static/media/DJD.66d30b40588f9fd6f1ae02a8f0573044.svg";
export { ForwardRef as ReactComponent };